export default function spacing(...props) {
  const step = 5
  const unit = "px"
  return props.map((factor = 0) => (isNaN(factor) ? factor : factor * step + unit)).join(" ")
}
